import React from "react";

const PurpleBottomGradient = ({ className }) => {
  return (
    <svg
      width="565"
      height="461"
      viewBox="0 0 565 461"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className || ""}
    >
      <g filter="url(#filter0_f_6386_26242)">
        <rect
          width="646"
          height="646"
          rx="323"
          transform="matrix(1 0 0 -1 -401 966)"
          fill="#5200FF"
          fillOpacity="0.32"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_6386_26242"
          x="-721"
          y="0"
          width="1286"
          height="1286"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="160"
            result="effect1_foregroundBlur_6386_26242"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default PurpleBottomGradient;
